export class ApplicationActivity {
    standardActivities: Array<string>;
    tenantActivities: Array<TimeKeepingActivity>;
}

export class TimeKeepingActivity {
    id: number;
    activityName: string;
    activityRate: number;
}



// WEBPACK FOOTER //
// ./src/app/admin/applicationactivity/application-activity.model.ts